<div class="bg-white dark:bg-gray-800 rounded-lg overflow-hidden h-full">
  <!-- Loading State -->
  @if (isLoading()) {
    <app-stock-accordion-skeleton></app-stock-accordion-skeleton>
  } @else if (stocks().length === 0) {
    <!-- Empty State -->
    <div class="p-12 text-center">
      <div class="text-gray-500 dark:text-gray-400">
        <h3 class="text-lg font-medium mb-2">No stocks found</h3>
        <p class="text-sm">There are currently no stocks to display.</p>
      </div>
    </div>
  } @else {
    <!-- PrimeNG Accordion -->
    <p-accordion [multiple]="false" class="h-full" styleClass="stock-list-accordion">
      @for (stock of stocks(); track trackByTicker($index, stock)) {
        <p-accordion-panel [value]="stock.ticker">
          <!-- Accordion Header -->
          <p-accordion-header>
            <div class="flex items-center justify-between w-full">
              <app-company-display
                [clickable]="false"
                [ticker]="stock.ticker"
                [companyName]="stock.name"
                [logoUrl]="stock.logoUrl"
                [currentPrice]="stock.currentPrice"
                [sma20]="stock.sma20"
                [sma50]="stock.sma50"
                [sma200]="stock.sma200"
                [buyPrice]="stock.buyPrice">
              </app-company-display>
            </div>
          </p-accordion-header>

          <!-- Accordion Content -->
          <p-accordion-content>
            <div class="space-y-4">
              <!-- Pricing Grid (2 columns) -->
              <div class="grid grid-cols-2 gap-4">
                <div class="text-center">
                  <div class="text-sm text-gray-600 dark:text-gray-400">Current Price</div>
                  <div class="text-lg font-semibold text-gray-900 dark:text-white">
                    {{ stock.currentPrice | wsyCurrency }}
                  </div>
                </div>
                <div class="text-center">
                  <div class="text-sm text-gray-600 dark:text-gray-400">Sticker Price</div>
                  <div class="text-lg font-semibold text-gray-900 dark:text-white">
                    @if (stock.stickerPrice) {
                      <span>{{ stock.stickerPrice | wsyCurrency }}</span>
                    } @else {
                      <span class="text-gray-400 dark:text-gray-500">-</span>
                    }
                  </div>
                </div>
                <div class="text-center">
                  <div class="text-sm text-gray-600 dark:text-gray-400">Buy Price</div>
                  <div class="text-lg font-semibold text-gray-900 dark:text-white">
                    {{ stock.buyPrice | wsyCurrency }}
                  </div>
                </div>
                <div class="text-center">
                  <div class="text-sm text-gray-600 dark:text-gray-400">Discount</div>
                  <div class="text-lg font-semibold">
                    @if (stock.discount !== undefined) {
                      @if (stock.discount < 0) {
                        <wsy-premium-badge [show]="true"></wsy-premium-badge>
                      } @else {
                        <span>{{ stock.discount | wsyPercentage }}</span>
                      }
                    } @else {
                      <span class="text-gray-400 dark:text-gray-500">-</span>
                    }
                  </div>
                </div>
              </div>

              <!-- Scores Grid (3 columns) -->
              <div class="grid grid-cols-3 gap-4">
                <div class="flex flex-col items-center">
                  <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">Yardie</div>
                  <wsy-score-badge [score]="stock.wsyScore"></wsy-score-badge>
                </div>
                <div class="flex flex-col items-center">
                  <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">Mgmt</div>
                  <wsy-score-badge [score]="stock.mgmtScore"></wsy-score-badge>
                </div>
                <div class="flex flex-col items-center">
                  <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">Growth</div>
                  <wsy-score-badge [score]="stock.growthScore"></wsy-score-badge>
                </div>
              </div>

              <!-- Action Footer -->
              <div class="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-gray-700">
                <!-- <app-watchlist-add-icon-button
                  [ticker]="stock.ticker">
                </app-watchlist-add-icon-button> -->
                <app-watchlist-add-button [ticker]="stock.ticker" [showCount]="false"></app-watchlist-add-button>
                <button
                  (click)="onStockClick(stock)"
                  class="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-lg transition-colors">
                  Details
                </button>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  }
</div>
